import Vue from 'vue'
import Vuex from 'vuex'
import { imgUrl } from '@/utils/config'
Vue.use(Vuex)

const state = {
    scrollbarWidth: 17,// 滚动条宽度
    pageType: 1,// 1是中文，2是英文
    sizeType: "pc",// 手机还是电脑
    imgUrl,
}

const store = new Vuex.Store({
    state,
})

export default store


// WEBPACK FOOTER //
// ./src/vuex/store.js